// Viewport dimensions
export const DESKTOP_VIEWPORT_WIDTH = 1200; // pixels
export const MOBILE_VIEWPORT_WIDTH = 375; // iPhone X width
export const MOBILE_VIEWPORT_HEIGHT = 812; // iPhone X height

// Phone frame dimensions (slightly larger than viewport)
export const PHONE_FRAME_WIDTH = 390;
export const PHONE_FRAME_HEIGHT = 844; 